(function($, Drupal) {

  'use strict';

  /*----------------------------------------
   Stop preload animations
   https://css-tricks.com/transitions-only-after-page-load/
  ----------------------------------------*/
  Drupal.behaviors.removePreload = {
    attach: function (context, settings) {
      $(window, context).once('removePreload').on('load', function () {
        $('body').removeClass('preload');
      });
    }
  };

  /*----------------------------------------
   Example
  ----------------------------------------*/
  Drupal.behaviors.calculations = {
    attach: function(context, settings) {

      jQuery.fn.updateIMC = function () {
        var setweight = parseFloat($("#edit-field-calc-weight-0-value").val());
        var setheight = parseFloat($("#edit-field-calc-height-0-value").val());
        var heightto2 = setheight * setheight;
        var total = setweight / heightto2;
        var total2 = total.toFixed(2);
        $("#edit-field-calc-imc-0-value").val(total2);
       };

      $('#edit-field-calc-weight-0-value').keyup(function () {
        $("#edit-field-calc-imc-0-value").updateIMC();
      });

      $('#edit-field-calc-height-0-value').keyup(function () {
        $("#edit-field-calc-imc-0-value").updateIMC();
      });

      // Calculate and set Heart Rate from the value of age field, in real time
       $('#edit-field-calc-age-0-value').keyup(function () {
        var setAge = parseFloat($("#edit-field-calc-age-0-value").val());
        var heartrate01 = 208 - (0.7 * setAge);
        var heartrate02 = 220 - (setAge);
        if (setAge >= 40) {
          $("#edit-field-calc-heart-rate-0-value").removeClass('bellow-40');
          $("#edit-field-calc-heart-rate-0-value").addClass('over-40');
          $("#edit-field-calc-heart-rate-0-value").val(heartrate01);
          //console.log('equal or more than 40');
        } else {
          $("#edit-field-calc-heart-rate-0-value").addClass('bellow-40');
          $("#edit-field-calc-heart-rate-0-value").removeClass('over-40');
          //console.log('equal or minor than 39');
          $("#edit-field-calc-heart-rate-0-value").val(heartrate02);
        }

        if (setAge >= 40) {
          // Calculate 70 percent of Heart rate from Heart Rate value.
          var percentHeartRate70a = heartrate01 * 70 / 100;
          $("#edit-field-calc-work-rate-70-0-value").val(percentHeartRate70a).addClass('hr-percent-70');
        } else {
          // Calculate 75 percent of Heart rate from Heart Rate value.
          var percentHeartRate70b = heartrate01 * 70 / 100;
          $("#edit-field-calc-work-rate-70-0-value").val(percentHeartRate70b).addClass('hr-percent-70');
        }

        if (setAge >= 40) {
          // Calculate 70 percent of Heart rate from Heart Rate value.
          var percentHeartRate75a = heartrate02 * 75 / 100;
          $("#edit-field-calc-work-rate-75-0-value").val(percentHeartRate75a).addClass('hr-percent-70');
        } else {
          // Calculate 75 percent of Heart rate from Heart Rate value.
          var percentHeartRate75b = heartrate02 * 75 / 100;
          $("#edit-field-calc-work-rate-75-0-value").val(percentHeartRate75b).addClass('hr-percent-75');
        }
      });


      //Add Reduction Factor
      jQuery('#edit-field-calc-age-0-value').keyup(function () {
       var setAgeforRed = parseFloat($("#edit-field-calc-age-0-value").val());
       if (setAgeforRed <= 39) {
         jQuery("#edit-field-calc-age-reduction-0-value").addClass('workingfor39');
         jQuery("#edit-field-calc-age-reduction-0-value").val('1.0');
       } else if ( ($("#edit-field-calc-age-0-value").val() == 40) || ($("#edit-field-calc-age-0-value").val() <= 49)) {
         $("#edit-field-calc-age-reduction-0-value").val('0.95');
       } else if ( ($("#edit-field-calc-age-0-value").val() == 50) ||($("#edit-field-calc-age-0-value").val() <= 59)) {
         $("#edit-field-calc-age-reduction-0-value").val('0.90');
       } else if ( ($("#edit-field-calc-age-0-value").val() == 60) ||($("#edit-field-calc-age-0-value").val() <= 69)) {
        $("#edit-field-calc-age-reduction-0-value").val('0.80');
       }
       else {
         $("#edit-field-calc-age-reduction-0-value").val('0.70');
       }
      });

    }
  };

})(jQuery, Drupal);
